export enum QuoteSource {
    Manual = 'Manual',
    API = 'API',
    Email = 'Email',
}
